const getScrollCallback = ({ downTransitionPoints, upTransitionPoints, doScrollDownTransition, doScrollUpTransition, initialSlide }) => {
  // Declare variables outside the callback due to performance reasons.
  let currentSlide = initialSlide === undefined ? 1 : initialSlide
  let toSlide = null
  let toSlideTransitionPoint = null
  let scrollTop = null
  let direction = null

  return (event) => {
    scrollTop = event.detail.scrollTop
    direction = event.detail.direction
    // Scrolling down.
    if (direction === 'down') {
      toSlide = currentSlide + 1
      toSlideTransitionPoint = downTransitionPoints[toSlide]
      if (scrollTop >= toSlideTransitionPoint) {
        doScrollDownTransition(toSlide)
        currentSlide = toSlide
      }
    } else {
      toSlide = currentSlide - 1
      toSlideTransitionPoint = upTransitionPoints[toSlide]

      if (scrollTop < toSlideTransitionPoint) {
        doScrollUpTransition(toSlide)
        currentSlide = toSlide
      }
    }
  }
}

export default getScrollCallback